/**
 * Decide what phone number (if any) to persist to the cart when the checkout
 * form is submitted.
 *
 * The checkout writes the contact phone to the cart only on the phone input's
 * blur event. So a phone that was prefilled (e.g. a support agent loading a
 * customer's saved info) or typed but never blurred is shown in the form yet
 * never reaches the cart — and therefore never reaches the order or the
 * shipping partner. Flushing it on submit closes that gap.
 *
 * Returns the phone to send, or null when there is nothing to persist (no phone
 * entered, or the cart already holds the same value).
 */
export function phoneToPersistOnSubmit(
  formPhone: string | undefined,
  cartPhone: string | null,
): string | null {
  const phone = (formPhone ?? "").trim();
  if (!phone) return null;
  if (phone === (cartPhone ?? "").trim()) return null;
  return phone;
}
